import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { AuditLogsComponent } from './audit-logs.component';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        AuditLogsComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        DataTablesModule,
        MaterialModule
    ],
    exports: [
        AuditLogsComponent
    ]
})
export class AuditLogsModule { }
